import React, { useEffect } from 'react';
import { NativeModules, StyleSheet, View } from 'react-native';

import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp, NativeStackScreenProps } from '@react-navigation/native-stack';

import { LoadingSpinner } from '@/components/LoadingSpinner';
import { ds } from '@/components/lib/design.system';
import { useDeposit } from '@/feature/deposit/hooks/use-deposit';
import { usePreventAndroidBackNavigation } from '@/hooks/use-prevent-android-back-navigation';
import { DepositStackParamList } from '@/navigation/types';
import { common } from '@/styles/styles';
import { getWalletErrorCode } from '@/utils/get-wallet-error-code';

import { PaymentMethodTypes } from '../const';
import { useDepositStatusStore } from '../hooks/use-deposit-status-store';

const { PaymentsWebView } = NativeModules;

const styles = StyleSheet.create({
    loaderContainer: { backgroundColor: ds.colorValue.background.neutral.base },
});

type ScreenProps = NativeStackScreenProps<DepositStackParamList, 'MazoomaDepositWebViewModal'>;

export const MazoomaDepositWebView = ({ route }: ScreenProps) => {
    const { currency = 'USD', payment_token = '', payment_type_id = '' } = route.params || {};
    const selectedPaymentMethodType = PaymentMethodTypes.PaysafeMazooma;
    const navigation = useNavigation<NativeStackNavigationProp<DepositStackParamList>>();
    const selectedAmount = useDepositStatusStore(state => state.selectedAmount);
    const { mutate: deposit } = useDeposit();

    usePreventAndroidBackNavigation();

    useEffect(() => {
        deposit(
            {
                type: PaymentMethodTypes.PaysafeMazooma,
                currency,
                payment_token,
                payment_type_id,
            },
            {
                onSuccess: data => {
                    PaymentsWebView.openURL(data.payment_url); // Open out-of-process WebView
                    navigation.goBack(); // Navigate back to prevent being stuck on loading screen
                },
                onError: error => {
                    navigation.navigate('FailedDepositModal', {
                        paymentProvider: selectedPaymentMethodType,
                        errorCode: getWalletErrorCode(error),
                    });
                },
            }
        );
    }, [currency, deposit, navigation, payment_token, payment_type_id, selectedAmount, selectedPaymentMethodType]);

    return (
        <View style={[common.flex, styles.loaderContainer, common.justifyCenter]}>
            <LoadingSpinner />
        </View>
    );
};
